<template>
  <multiselect
    v-model="model"
    :options="options"
    :custom-label="translatedOption"
    :placeholder="$t('formExportDataPlaceholder')"
    deselect-label=""
    :allow-empty="false"
    :loading="isLoading"
    :class="stateClass" />
</template>

<script>
import DropdownMixin from '@/mixins/DropdownMixin';

export default {
  mixins: [ DropdownMixin ],
  methods: {
    findOptions() {
      return new Promise(resolve => resolve([ 'EXPORT_DATA_ALL_PLATE', 'EXPORT_DATA_SELECTION', 'EXPORT_DATA_WELL_NAME' ]));
    },
    translatedOption(option) {
      return this.$t(option);
    }
  }
};
</script>
